/**
 * Categoria de um serviço sugerido pela IA, usada exclusivamente para
 * tagueamento (item_category em eventos do GTM/GA4, ex: view_item_list).
 *
 * Reflete a mesma classificação já aplicada em ServicesComponent para
 * separar os serviços entre as abas "Manutenção", "Serviços Adicionais"
 * e "Recall" (ver ServicesComponent.getOptionalServices / getRecall).
 */
export enum AiServiceItemCategory {
  MAINTENANCE = 'maintenance',
  ADDITIONAL_SERVICE = 'additional_service',
  RECALL = 'recall',
}
